export const Icon123MS = <span className="material-symbols-outlined">123</span>;

export const IconAccountBalanceMS = (
  <span className="material-symbols-outlined">account_balance_wallet</span>
);

export const IconAddMS = <span className="material-symbols-outlined">add</span>;

export const IconAddPhotoAlternateMS = (
  <span className="material-symbols-outlined">add_photo_alternate</span>
);

export const IconApartmentMS = (
  <span className="material-symbols-outlined">apartment</span>
);

export const IconDashboardMS = (
  <span className="material-symbols-outlined">dashboard</span>
);

export const IconTrendingUpMS = (
  <span className="material-symbols-outlined">trending_up</span>
);

export const IconTrendingDownMS = (
  <span className="material-symbols-outlined">trending_down</span>
);

export const IconTrendingFlatMS = (
  <span className="material-symbols-outlined">trending_flat</span>
);

export const IconArchiveMS = (
  <span className="material-symbols-outlined">archive</span>
);

export const IconArrowBackMS = (
  <span className="material-symbols-outlined">arrow_back_ios_new</span>
);

export const IconArrowCircleLeftMS = (
  <span className="material-symbols-outlined">arrow_circle_left</span>
);

export const IconArrowDownwardMS = (
  <span className="material-symbols-outlined">arrow_downward</span>
);

export const IconArrowForwardIosMS = (
  <span className="material-symbols-outlined arrow-forward-ios">
    arrow_forward_ios
  </span>
);

export const IconArrowUpwardMS = (
  <span className="material-symbols-outlined">arrow_upward</span>
);

export const IconAssignmentMS = (
  <span className="material-symbols-outlined">assignment</span>
);

export const IconAttachFileMS = (
  <span className="material-symbols-outlined">attach_file</span>
);

export const IconBlockMS = (
  <span className="material-symbols-outlined">block</span>
);

export const IconBookmarkMS = (
  <span className="material-symbols-outlined">bookmark</span>
);

export const IconCalendarMonthMS = (
  <span className="material-symbols-outlined">calendar_month</span>
);

export const IconCalendarTodayMS = (
  <span className="material-symbols-outlined">calendar_today</span>
);

export const IconCancelMS = (
  <span className="material-symbols-outlined">cancel</span>
);

export const IconCheckMS = (
  <span className="material-symbols-outlined">check</span>
);

export const IconCheckBoxMS = (
  <span className="material-symbols-outlined">check_box</span>
);

export const IconCheckCircleMS = (
  <span className="material-symbols-outlined">check_circle</span>
);

export const IconCheclistRtlMS = (
  <span className="material-symbols-outlined">checklist_rtl</span>
);

export const IconCircleMS = (
  <span className="material-symbols-outlined">circle</span>
);

export const IconCloseMS = (
  <span className="material-symbols-outlined">close</span>
);

export const IconCommentMS = (
  <span className="material-symbols-outlined">comment</span>
);

export const IconContentCopyMS = (
  <span className="material-symbols-outlined">content_copy</span>
);

export const IconContractEditMS = (
  <span className="material-symbols-outlined">contract_edit</span>
);

export const IconCurrencyExchangeCopyMS = (
  <span className="material-symbols-outlined">currency_exchange</span>
);

export const IconDeleteMS = (
  <span className="material-symbols-outlined">delete</span>
);

export const IconDescriptionMS = (
  <span className="material-symbols-outlined">description</span>
);

export const IconDesignServicesMS = (
  <span className="material-symbols-outlined">design_services</span>
);

export const IconDocumentMS = (
  <span className="material-symbols-outlined">docs</span>
);

export const IconDoorFrontMS = (
  <span className="material-symbols-outlined">door_front</span>
);

export const IconDownloadMS = (
  <span className="material-symbols-outlined">download</span>
);

export const IconEastMS = (
  <span className="material-symbols-outlined">east</span>
);

export const IconEditMS = (
  <span className="material-symbols-outlined">edit</span>
);

export const IconEditNoteMS = (
  <span className="material-symbols-outlined">edit_note</span>
);

export const IconEditDocumentMS = (
  <span className="material-symbols-outlined">edit_document</span>
);

export const IconEngineeringMS = (
  <span className="material-symbols-outlined">engineering</span>
);

export const IconErrorMS = (
  <span className="material-symbols-outlined">error</span>
);

export const IconExpandLessMS = (
  <span className="material-symbols-outlined">expand_less</span>
);

export const IconExpandMoreMS = (
  <span className="material-symbols-outlined">expand_more</span>
);

export const IconFactCheckMS = (
  <span className="material-symbols-outlined">fact_check</span>
);

export const IconFilePresentMS = (
  <span className="material-symbols-outlined">file_present</span>
);

export const IconFolderOpenMS = (
  <span className="material-symbols-outlined">folder_open</span>
);

export const IconFormatAlignCenterMS = (
  <span className="material-symbols-outlined">format_align_center</span>
);

export const IconFormatAlignJustifyMS = (
  <span className="material-symbols-outlined">format_align_justify</span>
);

export const IconFormatAlignLeftMS = (
  <span className="material-symbols-outlined">format_align_left</span>
);

export const IconFormatAlignRightMS = (
  <span className="material-symbols-outlined">format_align_right</span>
);

export const IconFormatBoldMS = (
  <span className="material-symbols-outlined">format_bold</span>
);

export const IconFormatClearMS = (
  <span className="material-symbols-outlined">format_clear</span>
);

export const IconFormatColorTextMS = (
  <span className="material-symbols-outlined">format_color_text</span>
);

export const IconFormatH1MS = (
  <span className="material-symbols-outlined">h1</span>
);

export const IconFormatH2MS = (
  <span className="material-symbols-outlined">h2</span>
);

export const IconFormatItalicMS = (
  <span className="material-symbols-outlined">format_italic</span>
);

export const IconFormatListBulletedMS = (
  <span className="material-symbols-outlined">format_list_bulleted</span>
);

export const IconFormatListNumberedMS = (
  <span className="material-symbols-outlined">format_list_numbered</span>
);

export const IconFormatStrikethroughMS = (
  <span className="material-symbols-outlined">format_strikethrough</span>
);

export const IconFormatUnderlinedMS = (
  <span className="material-symbols-outlined">format_underlined</span>
);

export const IconInkHighlighterMS = (
  <span className="material-symbols-outlined">ink_highlighter</span>
);

export const IconLinkMS = (
  <span className="material-symbols-outlined">link</span>
);

export const IconFullscreenMS = (
  <span className="material-symbols-outlined">fullscreen</span>
);

export const IconFullscreenExitMS = (
  <span className="material-symbols-outlined">fullscreen_Exit</span>
);

export const IconHomeMS = (
  <span className="material-symbols-outlined">home</span>
);

export const IconHubMS = <span className="material-symbols-outlined">hub</span>;

export const IconPropellerMS = (
  <span className="material-symbols-outlined">mode_fan</span>
);

export const IconInboxMS = (
  <span className="material-symbols-outlined">inbox</span>
);

export const IconInfoMS = (
  <span className="material-symbols-outlined">info</span>
);

export const IconInventoryMS = (
  <span className="material-symbols-outlined">inventory</span>
);

export const IconKeyMS = <span className="material-symbols-outlined">key</span>;

export const IconKeyboardArrowLeftMS = (
  <span className="material-symbols-outlined">keyboard_arrow_left</span>
);

export const IconKeyboardArrowRightMS = (
  <span className="material-symbols-outlined">keyboard_arrow_right</span>
);

export const IconKeyboardDoubleArrowDownMS = (
  <span className="material-symbols-outlined">keyboard_double_arrow_down</span>
);

export const IconKeyboardDoubleArrowLeftMS = (
  <span className="material-symbols-outlined">keyboard_double_arrow_left</span>
);

export const IconKeyboardDoubleArrowRightMS = (
  <span className="material-symbols-outlined">keyboard_double_arrow_right</span>
);

export const IconKeyboardDoubleArrowUpMS = (
  <span className="material-symbols-outlined">keyboard_double_arrow_up</span>
);

export const IconListAltMS = (
  <span className="material-symbols-outlined">list_alt</span>
);

export const IconLocationCityMS = (
  <span className="material-symbols-outlined">location_city</span>
);

export const IconLocationOnMS = (
  <span className="material-symbols-outlined">location_on</span>
);

export const IconLogoutMS = (
  <span className="material-symbols-outlined">logout</span>
);

export const IconMapMS = <span className="material-symbols-outlined">map</span>;

export const IconMessageMS = (
  <span className="material-symbols-outlined">message</span>
);

export const IconMoreVertMS = (
  <span className="material-symbols-outlined">more_vert</span>
);

export const IconNotesMS = (
  <span className="material-symbols-outlined">notes</span>
);

export const IconNotificationsMS = (
  <span className="material-symbols-outlined">notifications</span>
);

export const IconOpenInNewMS = (
  <span className="material-symbols-outlined">open_in_new</span>
);

export const IconPaidMS = (
  <span className="material-symbols-outlined">paid</span>
);

export const IconPaymentsMS = (
  <span className="material-symbols-outlined">payments</span>
);

export const IconPersonMS = (
  <span className="material-symbols-outlined">person</span>
);

export const IconPersonAddMS = (
  <span className="material-symbols-outlined">person_add</span>
);

export const IconPhotoLibraryMS = (
  <span className="material-symbols-outlined">photo_library</span>
);

export const IconPlaylistAddMS = (
  <span className="material-symbols-outlined">playlist_add</span>
);

export const IconQrCodeScannerMS = (
  <span className="material-symbols-outlined">qr_code_scanner</span>
);

export const IconRadioButtonCheckedMS = (
  <span className="material-symbols-outlined">radio_button_checked</span>
);

export const IconRemoveMS = (
  <span className="material-symbols-outlined">remove</span>
);

export const IconRunningWithErrorsMS = (
  <span className="material-symbols-outlined">running_with_errors</span>
);

export const IconScheduleMS = (
  <span className="material-symbols-outlined">schedule</span>
);

export const IconSearchMS = (
  <span className="material-symbols-outlined">search</span>
);

export const IconSendMS = (
  <span className="material-symbols-outlined">send</span>
);

export const IconSwapVertMS = (
  <span className="material-symbols-outlined">swap_vert</span>
);

export const IconTableViewMS = (
  <span className="material-symbols-outlined">table_view</span>
);

export const IconTaskAltMS = (
  <span className="material-symbols-outlined">task_alt</span>
);

export const IconTimerMS = (
  <span className="material-symbols-outlined">timer</span>
);

export const IconTimelapseMS = (
  <span className="material-symbols-outlined">timelapse</span>
);

export const IconTuneMS = (
  <span className="material-symbols-outlined">tune</span>
);

export const IconUploadMS = (
  <span className="material-symbols-outlined">upload</span>
);

export const IconViewArrayMS = (
  <span className="material-symbols-outlined">view_array</span>
);

export const IconViewKanbanMS = (
  <span className="material-symbols-outlined">view_kanban</span>
);

export const IconViewListMS = (
  <span className="material-symbols-outlined">view_list</span>
);

export const IconGridViewMS = (
  <span className="material-symbols-outlined">grid_view</span>
);

export const IconVisibilityMS = (
  <span className="material-symbols-outlined">visibility</span>
);

export const IconVisibilityOffMS = (
  <span className="material-symbols-outlined">visibility_off</span>
);

export const IconWarningMS = (
  <span className="material-symbols-outlined warning-icon">warning</span>
);

export const IconPendingMS = (
  <span className="material-symbols-outlined">pending</span>
);

export const IconVerifiedMS = (
  <span className="material-symbols-outlined">verified</span>
);

export const IconTroubleshootMS = (
  <span className="material-symbols-outlined">troubleshoot</span>
);

export const IconEmailMS = (
  <span className="material-symbols-outlined">email</span>
);

export const IconSouthdMS = (
  <span className="material-symbols-outlined">south</span>
);

export const IconNorthdMS = (
  <span className="material-symbols-outlined">north</span>
);

export const IconMobileDataArrowsMS = (
  <span className="material-symbols-outlined">mobiledata_arrows</span>
);

export const IconArrowForwardMS = (
  <span className="material-symbols-outlined arrow-forward">arrow_forward</span>
);

export const IconHistoryMS = (
  <span className="material-symbols-outlined">history</span>
);

export const IconContactsMS = (
  <span className="material-symbols-outlined">contacts</span>
);

export const IconEventMS = (
  <span className="material-symbols-outlined">event</span>
);

export const IconHomeWorkMS = (
  <span className="material-symbols-outlined">home_work</span>
);

export const IconForumMS = (
  <span className="material-symbols-outlined">forum</span>
);

export const IconUnfoldMoreMS = (
  <span className="material-symbols-outlined">unfold_more</span>
);

export const IconUnfoldLessMS = (
  <span className="material-symbols-outlined">unfold_less</span>
);

export const IconPictureAsPdfMS = (
  <span className="material-symbols-outlined">picture_as_pdf</span>
);

export const IconFilterListMS = (
  <span className="material-symbols-outlined">filter_list</span>
);

export const IconRequestQuoteMS = (
  <span className="material-symbols-outlined">request_quote</span>
);

export const IconBankMS = (
  <span className="material-symbols-outlined">account_balance</span>
);

export const IconBusinessMS = (
  <span className="material-symbols-outlined">business</span>
);

export const IconAutoAwesomeMS = (
  <span className="material-symbols-outlined">auto_awesome</span>
);

export const IconDragIndicatorMS = (
  <span className="material-symbols-outlined">drag_indicator</span>
);

export const IconLockMS = (
  <span className="material-symbols-outlined">lock</span>
);

export const IconUndoMS = (
  <span className="material-symbols-outlined">undo</span>
);

export const IconRedoMS = (
  <span className="material-symbols-outlined">redo</span>
);

export const IconRestartAltMS = (
  <span className="material-symbols-outlined">restart_alt</span>
);

export const IconPaletteMS = (
  <span className="material-symbols-outlined">palette</span>
);

export const IconTitleMS = (
  <span className="material-symbols-outlined">title</span>
);

export const IconInsertPageBreakMS = (
  <span className="material-symbols-outlined">insert_page_break</span>
);

export const IconImageMS = (
  <span className="material-symbols-outlined">image</span>
);

export const IconZoomInMS = (
  <span className="material-symbols-outlined">zoom_in</span>
);

export const IconZoomOutMS = (
  <span className="material-symbols-outlined">zoom_out</span>
);

export const IconAutoStoriesMS = (
  <span className="material-symbols-outlined">auto_stories</span>
);

export const IconViewDayMS = (
  <span className="material-symbols-outlined">view_day</span>
);

export const IconPlayCircleMS = (
  <span className="material-symbols-outlined">play_circle</span>
);
